import { useAuthUser } from "./auth";
import { Home } from "./components/Home";
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { UnauthorizedComponent } from "./Unauthorized";

export const RoutesComponent = () => {

    const { checkRole } = useAuthUser();

    return <Routes >
        {
            AppRoutes.map((route, index) => {
            const { element, role, ...rest } = route;

            if (role && !checkRole(role))
            {
                return <Route key={index} {...rest}  element={<UnauthorizedComponent></UnauthorizedComponent>} />
            }
            else
            {
                return <Route key={index} {...rest} element={element} />
            }})}
    </Routes>
}